import React from 'react';
import { Box, CircularProgress, Container } from '@mui/material';
import Sidebar from '../Sidebar';

const PageContainer = ({ children, loading, onLogout, maxWidth = "lg" }) => {
    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <Sidebar onLogout={onLogout} />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                }}
            >
                {loading ? (
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CircularProgress sx={{ color: '#800020' }} />
                    </Box>
                ) : (
                    <Box sx={{ flex: 1, overflowY: 'auto', p: { xs: 2, md: 4 }, pt: { xs: 7, md: 4 } }}>
                        <Container maxWidth={maxWidth} disableGutters>
                            {children}
                        </Container>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default PageContainer;
